import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/everyone-challenge-hero-title.png'
import _imports_1 from '../images/zero-pic2.png'
import _imports_2 from '../images/for-moment-text.png'
import _imports_3 from '../images/reward-img-2.png'


const _withScopeId = n => (_pushScopeId("data-v-5a049b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-5 pt-5 d-none d-sm-block\" data-v-5a049b9e></div><div class=\"mt-5 pt-sm-5\" data-v-5a049b9e></div><div id=\"instruction\" class=\"font-Pretendar cola-color text-center\" data-v-5a049b9e><div data-v-5a049b9e><img class=\"title-header\" src=\"" + _imports_0 + "\" alt=\"모두의 챌린지 로고\" data-v-5a049b9e></div><h2 class=\"mt-5 text-14 text-50\" data-v-5a049b9e> 모두의 챌린지는 누구나 쉽게 참여할 수 있어요 <br data-v-5a049b9e> 나 혼자, 가족, 친구, 직장, 매장 등에서 <br data-v-5a049b9e> 투명 음료 페트병을 모아보세요! </h2></div>", 3)
const _hoisted_4 = {
  id: "rewards",
  class: "container",
  style: {"padding-bottom":"7.5rem"}
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"text-60 cola-color font-Noto d-none d-sm-block lh-sm mt-5\" data-v-5a049b9e> 보틀로 다시 태어나고 싶은 투명 음료병을 <br data-v-5a049b9e> 도와준 나를 위한 특별한 선물 </div><div class=\"pt-5 mt-5 d-none d-sm-block\" data-v-5a049b9e></div><div class=\"pt-5 mt-5 d-none d-sm-block\" data-v-5a049b9e></div><div class=\"mt-5 mt-sm-0 font-Pretendar cola-color text-center d-flex flex-column align-items-center\" data-v-5a049b9e><img src=\"" + _imports_1 + "\" class=\"w-100\" data-v-5a049b9e><ul class=\"cola-color font-Pretendar ps-5 text-start item-text ul-lgx\" data-v-5a049b9e><li class=\"text-8\" data-v-5a049b9e> 코카-콜라 제로 500ml 패키지 일부에는 재생원료가 사용되었습니다. </li><li class=\"text-8\" data-v-5a049b9e> 코카-콜라 제로 500ml는 가입 시 기입한 휴대전화 번호를 통해 전국 GS25 편의점에서 사용 가능한 모바일 교환권으로 제공됩니다. </li><li class=\"text-8\" data-v-5a049b9e> 원더플 우산 텐트 케이스 길이는 112cm, 무게는 2kg입니다. </li></ul></div>", 4)
const _hoisted_9 = { class: "d-flex justify-content-center" }
const _hoisted_10 = { class: "font-Pretendar ul-lgs" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mt-5 img-wtitle"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"d-none d-sm-flex align-items-center justify-content-center\" data-v-5a049b9e><svg width=\"30\" height=\"54\" viewBox=\"0 0 49 54\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5a049b9e><path d=\"M23.5723 15.2425C23.8084 7.95806 25.679 1.46654 26.4129 1.50675C27.1772 1.54803 27.9316 8.76514 28.1075 14.4357C28.2526 19.1457 27.9764 21.8942 29.8238 23.2612C31.0876 24.1935 32.3854 23.7775 35.0637 23.6531C41.1909 23.3687 47.3646 24.9707 47.4052 26.0311C47.4425 27.0582 41.8191 28.6974 36.4529 28.9898C32.6176 29.198 31.4882 28.5772 30.1836 29.618C28.1915 31.2093 29.0044 34.1226 28.7124 40.7541C28.5271 44.9942 27.8306 52.0857 26.8153 52.1432C25.8782 52.1954 24.1265 46.2559 23.8421 40.1287C23.5815 34.5215 24.7136 32.4219 23.0881 30.7129C21.5932 29.1386 19.59 29.8257 13.3465 29.6173C8.54584 29.4607 1.71981 28.787 1.67996 27.9077C1.63596 27.0445 8.08798 25.4821 13.9659 24.8428C18.7987 24.3164 20.8539 24.6721 22.3983 22.9834C23.9099 21.3357 23.4406 19.3617 23.5751 15.2381L23.5723 15.2425Z\" fill=\"#FFF681\" stroke=\"#F40000\" stroke-width=\"2.09011\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5a049b9e></path></svg></div><div class=\"d-block d-sm-none d-flex flex-column justify-content-center\" data-v-5a049b9e><svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5a049b9e><path d=\"M6.67093 3.88927C6.73211 2.00199 7.21675 0.320127 7.40689 0.330545C7.60491 0.341241 7.80037 2.21109 7.84594 3.68025C7.88354 4.90054 7.81198 5.61263 8.29062 5.96682C8.61803 6.20836 8.95429 6.10057 9.6482 6.06834C11.2357 5.99465 12.8352 6.40972 12.8457 6.68446C12.8554 6.95057 11.3984 7.37524 10.0081 7.45099C9.01444 7.50495 8.72182 7.3441 8.38382 7.61376C7.86772 8.02606 8.07831 8.78084 8.00266 10.499C7.95465 11.5975 7.77419 13.4348 7.51115 13.4497C7.26837 13.4632 6.81453 11.9244 6.74084 10.3369C6.67333 8.88419 6.96663 8.34022 6.54548 7.89745C6.15818 7.48955 5.63918 7.66757 4.02159 7.61358C2.7778 7.573 1.00927 7.39846 0.998949 7.17066C0.987549 6.947 2.65917 6.54221 4.18205 6.37657C5.43417 6.24019 5.96664 6.33236 6.36678 5.89484C6.75841 5.46794 6.63681 4.9565 6.67167 3.88814L6.67093 3.88927Z\" fill=\"#FFF681\" stroke=\"#F40000\" stroke-width=\"0.541517\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-5a049b9e></path></svg></div>", 2)
const _hoisted_14 = { class: "d-flex align-items-center text-10 text-38 lh-sm" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "",
    class: "img-75"
  })
], -1))
const _hoisted_16 = { id: "schedule" }
const _hoisted_17 = { class: "step-apply-collection" }
const _hoisted_18 = { class: "container pe-0 pe-sm-3" }
const _hoisted_19 = { class: "qna-wrapper" }
const _hoisted_20 = { class: "container" }

import { onMounted, onUnmounted } from 'vue';
import HeadingBox from '../components/heading-box.vue';
import ChallengeList from '../components/challenge-list.vue';
import StepApplyCollection from '@/templates/campaign-cocacola-season-6/components/step-apply-collection.vue';
import QuestionAnswerSs6 from '@/templates/campaign-cocacola-season-6/components/question-answer-ss6.vue';
import BoxMoving from '@/templates/campaign-cocacola-season-6/components/box-moving.vue';
import DividedBoxRow from '@/templates/campaign-cocacola-season-6/components/divided-box-row.vue';
import type { Challenge } from './model/challenge';


export default /*#__PURE__*/_defineComponent({
  props: {
    challenges: null
  },
  emits: ['show-error'],
  setup(__props: any, { emit }) {

const props = __props as {
  challenges: Challenge[];
}



const questionTabs = [
  {
    id: 'general',
    title: '지원하기',
    questions: [
      {
        id: 'q1',
        question: '지원이 완료되었는지 어떻게 알 수 있을까요?',
        answer: '지원이 완료되면 등록한 핸드폰 번호로 카카오톡 메시지가 발송되며, 마이페이지에서도 확인할 수 있어요.\n'
      },
      {
        id: 'q2',
        question: '여러 번 참여할 수 있나요?\n',
        answer: '시즌 6에서는 회차마다 한 번씩, 총 2번의 참여 기회가 있어요. 계정별로 회차당 1회씩 지원 가능하니, 이번 회차에 선정되지 못해도 재도전할 수 있답니다. 1회차에 선정되지 못했다면 2회차 지원 시 선정 확률 50% UP!  단, 시즌 내에 이미 선정되어 캠페인에 참여한 원더플 피플은 다시 참여 기회를 가질 수 없는 점 잊지 마세요!'
      }
    ]
  },
  {
    id: 'collection-request',
    title: '수거 신청',
    questions: [
      {
        id: 'q3',
        question: '페트병 뚜껑을 꼭 닫아야 하나요?',
        answer: '현재 환경부에서는 페트병을 압착 후, 공기가 다시 들어가지 않게끔 병뚜껑을 꼭 닫아서 분리배출하는 것을 권하고 있습니다. 그 이유는, 뚜껑을 닫은 상태여도 재활용에는 문제가 없고, 가능한 많은 양의 페트병을 한 번에 잘 모아서 수거가 되는 것이 중요하기 때문인데요. 원더플 캠페인에서도 박스의 크기가 한정된 만큼, 페트병은 깨끗하게 헹구고 잘 말린 다음 압착 후 뚜껑을 닫아서 가능한 많이 모아 주시면 됩니다. \n'
      },
      {
        id: 'q4',
        question: '주소 변경 등의 이유로 개인 정보 변경하고 싶어요.\n',
        answer: '마이페이지에서 변경 가능해요. 등록된 주소지로 제로 웨이스트 박스 발송, 수거, 리워드 발송이 진행되므로 정확한 주소를 입력해 주세요.'
      },
      {
        id: 'q5',
        question: '제로 웨이스트 박스 배송비는 본인 부담인가요?\n',
        answer: '원더플 캠페인은 참여자들의 비용 부담 없이 무료로 진행돼요. 원더플 피플은 올바른 분리배출법에 따라 투명 음료 페트병을 모아 주기만 하면 끝!'
      },
      {
        id: 'q6',
        question: '캠페인 기간 내 박스를 다 못 채웠는데 어떡하죠?',
        answer: '수거 신청은 사전에 공지된 기간에만 가능해요. 약속된 기간 내 제로 웨이스트 박스가 수거되지 않으면 리워드가 제공되지 않아요. 미처 미션을 완수하지 못한 원더플 피플이 있다면 환경을 위해 제로 웨이스트 박스와 페트병은 자체적으로 분리배출해 주세요.'
      },
    ]
  },
  {
    id: 'rewards',
    title: '리워드/배송',
    questions: [
      {
        id: 'q7',
        question: '리워드 배송 일정이 궁금해요',
        answer: '올바른 방법으로 투명 음료 페트병을 모아 보내 주신 분들에 한 해 순차적으로 배송해 드려요. 제로 웨이스트 박스는 테라사이클에서 하나하나 검수하기 때문에 많은 시간이 소요된답니다. 캠페인 운영 과정에서 리워드 배송이 지연될 수 있는 점 양해 부탁드립니다.'
      },
      {
        id: 'q8',
        question: '리워드를 별도 구매할 수 있나요?\n',
        answer: '리워드는 캠페인에 참여해 주신 원더플 피플에게 감사의 의미로 제공되는 만큼 별도로 판매하지 않아요.'
      }
    ]
  }
];



const handleShowError = (message: string) => {
  emit('show-error', message);
};

const colaItems = [
  '정해진 기간 내에 제로 웨이스트 박스 모두 수거 신청해야 리워드를 받을 수 있어요.',
  '올바른 분리배출 방법을 지키지 않거나 투명 음료 페트병이 아닌 품목을 보내면 리워드를 받을 수 없어요.',
  '투명 음료 페트병을 제로 웨이스트 박스의 표시선까지 채워야 챌린지 성공!'
];

// Hash scroll functionality
const scrollToElement = (elementId: string) => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementPosition = element.offsetTop;
    // Use different padding based on screen width
    const padding = window.innerWidth < 600 ? 150 : 200; // 100px for mobile, 200px for desktop
    const offsetPosition = elementPosition - padding;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

const handleHashChange = () => {
  const url = window.location.href;
  const lastSlashIndex = url.lastIndexOf('/');
  let hash = lastSlashIndex !== -1 ? url.substring(lastSlashIndex + 1) : '';

  // Remove query parameters if they exist
  const queryIndex = hash.indexOf('?');
  if (queryIndex !== -1) {
    hash = hash.substring(0, queryIndex);
  }
  const validIds = ['instruction', 'rewards', 'schedule'];

  if (hash && validIds.includes(hash)) {
    // Add a small delay to ensure the DOM is ready
    setTimeout(() => {
      scrollToElement(hash);
    }, 100);
  }
};

onMounted(() => {
  // Check for hash on initial load
  handleHashChange();

  // Listen for hash changes
  window.addEventListener('hashchange', handleHashChange);
});

onUnmounted(() => {
  // Clean up event listener
  window.removeEventListener('hashchange', handleHashChange);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(BoxMoving, { "challenge-type": 'everyone' }),
    _createVNode(DividedBoxRow, { type: "everyone" }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(HeadingBox, {
        title: 'Challenge Reward',
        type: 'rewards'
      }),
      _hoisted_5,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colaItems, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "box-cola-item"
            }, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_14, _toDisplayString(item), 1)
            ])
          }), 64))
        ])
      ]),
      _hoisted_15
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(ChallengeList, {
        "challenge-type": 'everyone',
        challenges: props.challenges,
        onShowError: handleShowError
      }, null, 8, ["challenges"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(StepApplyCollection)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(QuestionAnswerSs6, { tabs: questionTabs })
      ])
    ])
  ]))
}
}

})